module.exports = __webpack_public_path__ + "img/crewFamilyXmasParty18.557aeb82.jpg";